    <template>
    <div class="bg-dark-create" :class="{ open: showmodal }"></div>
    <div class="edit_user" :class="{ dark: dark }">
        <div class="container edit_user_portal" :style="{ minHeight: minHeightStyle }">
        <Loader :isActive="hasLoaded" />
        <form @submit.prevent="handleSubmit" v-if="hasLoaded">
            <div class="modal-body info-perfil-image">
                <div class="form-group">
                <div class="form-label">
                    <img
                    class="temporary"
                    src="@/assets/user.png"
                    v-if="!userimagePreview && !userimage"
                    />
                    <img
                    :src="userimagePreview ? userimagePreview : userimage"
                    alt="Logo"
                    v-if="userimagePreview || userimage"
                    />
                </div>
                <div class="form-label">
                    <div class="form-label">
                    <label>Imagem de Perfil</label>
                    </div>
                    <div class="form-file">
                    <div class="file-wrapper primary">
                        <span class="thumbnail">
                        <span class="icon">
                            <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></path>
                            <rect
                                x="1.00049"
                                y="1.40454"
                                width="43.9461"
                                height="36.1909"
                                rx="2.58507"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></rect>
                            <circle
                                cx="14.8948"
                                cy="10.6676"
                                r="3.71629"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></circle>
                            </svg>
                        </span>
                        <span class="text">
                            Clique aqui para selecionar a imagem
                        </span>
                        </span>
                        <input
                        class="form-control"
                        type="file"
                        @change="updateFilePath"
                        accept=".png, .jpg, .jpeg, .webp"
                        />
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <v-divider></v-divider>

            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field
                    v-model="name"
                    label="Nome"
                    prepend-inner-icon="mdi-account"
                    variant="outlined"
                    required
                    placeholder="Nome"
                    hide-details="auto"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field
                        v-model="email"
                        label="E-mail"
                        prepend-inner-icon="mdi-email"
                        variant="outlined"
                        required
                        placeholder="E-mail"
                        hide-details="auto"
                        :theme="dark"
                        :color="dark ? '#FFFFFF' : 'primary'"
                        :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                        :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                    v-model="cpf"
                    label="CPF"
                    prepend-inner-icon="mdi-card-account-details"
                    variant="outlined"
                    dense
                    required
                    placeholder="CPF"
                    hide-details="auto"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                    v-model="phone"
                    label="Telefone"
                    prepend-inner-icon="mdi-phone"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    required
                    placeholder="Telefone"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                    v-model="idNumber"
                    label="RG"
                    prepend-inner-icon="mdi-card-account-details-outline"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="RG"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>   
                <v-col cols="12" md="2">
                    <v-text-field
                    v-model="cep"
                    label="CEP"
                    prepend-inner-icon="mdi-map-marker"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="CEP"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="8">
                    <v-text-field
                    v-model="address"
                    label="Endereço"
                    prepend-inner-icon="mdi-home"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Endereço"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                    <v-text-field
                    v-model="number"
                    label="Número"
                    prepend-inner-icon="mdi-numeric"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Número"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-text-field
                    v-model="addressComplement"
                    label="Complemento"
                    prepend-inner-icon="mdi-home-outline"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Casa, Apt..."
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                    v-model="city"
                    label="Cidade"
                    prepend-inner-icon="mdi-city"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Cidade"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select
                    v-model="county"
                    :items="states"
                    label="Estado"
                    prepend-inner-icon="mdi-map"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Selecione o estado"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-select>
                </v-col>
                
                <v-col cols="12" md="3">
                    <v-select
                    v-model="country"
                    :items="countries"
                    item-title="text"
                    item-value="value"
                    label="País"
                    prepend-inner-icon="mdi-earth"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Selecione o país"
                    :theme="dark"
                    :color="dark ? 'gray' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: white;' : ''"
                    :class="dark ? 'input-dark' : ''"
                  />                  
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="12" md="4">
                <v-text-field
                    v-model="oldPassword"
                    label="Senha Atual"
                    type="password"
                    prepend-inner-icon="mdi-lock"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Senha Atual"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                <v-text-field
                    v-model="password"
                    label="Nova Senha"
                    type="password"
                    prepend-inner-icon="mdi-lock-outline"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Nova Senha"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                <v-text-field
                    v-model="rePassword"
                    label="Confirme a Nova Senha"
                    type="password"
                    prepend-inner-icon="mdi-lock-check"
                    variant="outlined"
                    hide-details="auto"
                    dense
                    placeholder="Confirmar Nova Senha"
                    :theme="dark"
                    :color="dark ? '#FFFFFF' : 'primary'"
                    :style="dark ? 'background-color: #222; border-color: #fff; color: #fff;' : ''"
                    :class="dark ? 'input-dark' : ''"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="modal-footer" justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                color="#19c7d0"
                style="color: #fff;"
                type="submit"
                class="me-2"
                variant="elevated"
                >
                Atualizar Perfil
                </v-btn>
            </v-col>
            </v-row>
        </form>

        <v-dialog v-model="dialog" width="auto">
            <v-card
            max-width="400"
            prepend-icon="mdi-update"
            text="Um ou mais campo não foram preenchidos corretamente, por favor revise-os."
            title="Ops, há algum erro!"
            >
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialog = false"
                ></v-btn>
            </template>
            </v-card>
        </v-dialog>
        </div>
    </div>
    </template>
    <script>
        import { mapState } from 'vuex';
        import api from '@/utils/portal/user.js';
        import ApiCep from '@/utils/cep';
        import Loader from '@/components/Loader/loader.vue';
        import apiAWS from '@/utils/storage/aws';
        import { toast } from 'vue3-toastify';
        import { useTheme } from 'vuetify'

        export default {
            data() {
                return {
                    windowHeight: window.innerHeight,
                    hasLoaded: false,
                    showmodal: '',
                    name: '',
                    email: '',
                    cpf: '',
                    phone: '',
                    cep: '',
                    address: '',
                    number: '',
                    logo: '',
                    city: '',
                    state: '',
                    country: '',
                    county: '',
                    password: '',
                    rePassword: '',
                    oldPassword: '',
                    idUser: null,
                    idNumber: null,
                    userImgage: null,
                    userimagePreview: null,
                    addressComplement: '',
                    hasLoad: false,
                    dialog: false,
                    updatePassword: false,
                    states: [
                        'Acre',
                        'Alagoas',
                        'Amapá',
                        'Amazonas',
                        'Bahia',
                        'Ceará',
                        'Distrito Federal',
                        'Espírito Santo',
                        'Goiás',
                        'Maranhão',
                        'Mato Grosso',
                        'Mato Grosso do Sul',
                        'Minas Gerais',
                        'Pará',
                        'Paraíba',
                        'Paraná',
                        'Pernambuco',
                        'Piauí',
                        'Rio de Janeiro',
                        'Rio Grande do Norte',
                        'Rio Grande do Sul',
                        'Rondônia',
                        'Roraima',
                        'Santa Catarina',
                        'São Paulo',
                        'Sergipe',
                        'Tocantins',
                        'Outros',
                    ],
                    countries: [
                    { text: 'Brasil', value: 'br' },
                    { text: 'Outros', value: 'outro' }
                    ],
                };
            },
            props: {
                show: Boolean,
                id: Number,
            },
            components: {
                Loader,
            },
            computed: {
                ...mapState(['token', 'dark']),
                minHeightStyle() {
                    return this.windowHeight + 'px'
                }
            },
            mounted() {
                this.updateHeight()
                window.addEventListener('resize', this.updateHeight)
            },
            beforeUnmount() {
                window.removeEventListener('resize', this.updateHeight)
            },
            methods: {
                updateHeight() {
                    this.windowHeight = window.innerHeight - 121
                    console.log(window.innerHeight)
                    console.log(this.windowHeight)
                },
                async getDataUser() {
                    this.hasLoaded = false;
                    try {
                        const response = await api.getDataUser(this.token);
                        this.name = response.name;
                        this.email = response.email;
                        this.cpf = response.socialNumber;
                        this.phone = response.phone;
                        this.cep = response.postcode;
                        this.type = response.type;
                        this.address = response.address;
                        this.number = response.addressNumber;
                        this.city = response.city;
                        this.state = response.county;
                        this.country = response.country ?? 'br'
                        this.county = response.county;
                        this.idNumber = response.idNumber;
                        this.addressComplement = response.addressComplement;
                        this.hasLoaded = true;
                    } catch (error) {
                        console.error('Erro ao caregar dados de usuário', error);
                    }
                },
                async validateFields() {
                    if (
                        !this.name ||
                        !this.email ||
                        !this.cpf ||
                        !this.phone
                    ) {
                        this.dialog = true;
                        return false;
                    }
                    return true;
                },
                async editUser() {
                    const obj = {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        socialNumber: this.cpf,
                        idNumber: this.idNumber,
                        county: this.state,
                        country: this.country,
                        city: this.city,
                        address: this.address,
                        addressNumber: this.number,
                        addressComplement: this.addressComplement,
                        postcode: this.cep,
                        username: this.email,
                        type: this.type,
                        status: 1,
                        photo: this.logo,
                    };
                    try {
                        await api.EditUser(this.token, obj);
                        toast.success('Perfil atualizado com sucesso!');
                    } catch (error) {
                        toast.error('Erro ao editar o usuário');
                        console.error('Erro ao editar o usuário', error);
                    }
                },
                closetab() {
                    this.hasLoaded = false;
                    this.showmodal = false;
                    this.updatePassword = false;
                    this.$emit('open-tab', this.showmodal);
                },
                opentab() {
                    (this.show = true), this.$emit('open-tab', this.showmodal);
                },
                async saveModule() {
                    // Não usado mais, lógica movida para handleSubmit
                },
                async putFileAws(url, file) {
                    try {
                        await apiAWS.putFileAWS(url, file);
                    } catch (error) {
                        console.error('Erro ao enviar arquivo para AWS');
                    }
                },
                async updateFilePath(event) {
                    const file = event.target.files[0];
                    this.userimagePreview = URL.createObjectURL(file);

                    const formData = new FormData();
                    formData.append('file', this.userimage);

                    try {
                        const response = await apiAWS.getSignatureImagePortal(
                            this.token,
                            file.name
                        );
                        this.putFileAws(response.url, file);
                        this.logo = response.token;
                    } catch (error) {
                        console.error('Erro na geração do TOKEN AWS');
                    }
                },
                async changePassword() {
                    if (!this.oldPassword || !this.password || !this.rePassword) {
                        toast.error('Preencha todos os campos de senha.');
                        return false;
                    }
                    if (this.password !== this.rePassword) {
                        toast.error('As senhas devem ser iguais');
                        return false;
                    }
                    const obj = {
                        oldPassword: this.oldPassword,
                        newPassword: this.password,
                    };
                    try {
                        await api.changePassword(this.token, obj);
                        toast.success('Senha alterada com sucesso!');
                        this.showmodal = false;
                        this.$emit('open-tab', this.showmodal);
                        // Limpa os campos de senha
                        this.oldPassword = '';
                        this.password = '';
                        this.rePassword = '';
                    } catch (error) {
                        toast.error('Erro ao alterar a senha');
                        console.error(error);
                    }
                },
                async getCEP() {
                    try {
                        const response = await ApiCep.getDataCep(this.cep);
                        console.debug(response);
                        this.city = response.city;
                        this.address = response.street;
                        const state = response.state;
                        if (this.states.includes(state)) {
                            this.state = state;
                            this.country = 'br';
                        } else {
                            this.state = 'Outros';
                            this.country = 'outro';
                        }
                    } catch (error) {
                        console.error('Erro ao gerar dados do cep');
                    }
                },
                async handleSubmit() {
                    // Se todos os campos de senha estão preenchidos, faz alteração de senha
                    if (this.oldPassword && this.password && this.rePassword) {
                        await this.changePassword();
                    } else {
                        // Atualização de perfil
                        const valid = await this.validateFields();
                        if (!valid) return;
                        await this.editUser();
                        this.showmodal = false;
                        this.$emit('open-tab', this.showmodal);
                    }
                },
                dark: {
                     immediate: true,
                        handler(val) {
                            const theme = useTheme()
                            theme.global.name.value = val ? 'dark' : 'light'
                        }
                }
            },
            created() {
                this.getDataUser();
            },

            watch: {
                show(novoValor) {
                    this.showmodal = this.show;
                    this.idUser = this.id;
                    this.getDataUser();
                },
            },
        };
    </script>
    <style scoped>
        @import '../../../components/Admin/Users/Edituser/edituser.css';
        .modal-content {
            padding: 20px;
        }
        .modal-body.info-perfil-image .form-group {
            display: flex;
            gap: 20px;
            align-items: center;
            justify-content: space-between;
        }
        .modal-body.info-perfil-image .form-group > .form-label:nth-child(2) {
            width: 70%;
        }
        span.text {
            font-size: 11px;
        }
        .form-group {
            margin: 10px 5px !important;
        }

        .modal-body.double.less .form-group:first-child {
            width: 100%;
        }
        .modal-footer > button {
            width: 10%;
            min-width: 180px;
        }
        .modal-footer {
            gap: 10px;
        }
        .edit_user.dark {
            background: black;
        }
        .edit_user {
            background: rgb(255, 255, 255);
        }
        .edit_user.dark .form-group .form-input .form-control {
            background-color: grey;
            color: white;
            border-color: #000000;
        }
        .dark .form-group .form-label label {
            color: white;
        }
        .edit_user.dark select.form-select {
            color: white;
            background-color: grey;
            border-color: black;
        }
        .edit_user.dark input.form-control {
            background-color: #808080;
            border-color: black;
            color: white;
        }
        input.form-control {
            background-color: #ffffff;
            border-color: #dbdcde;
            color: rgb(0, 0, 0);
        }

        .container.edit_user_portal {
            max-width: 1500px !important;
            margin: 0px auto !important;
            width: 100% !important;
            border-radius: 10px;
            padding: 30px 100px;
        }
        @media (max-width: 768px) {
            .container.edit_user_portal {
                padding: 30px 20px;
                width: 100% !important;
                max-width: 100% !important;
            }
        }
        .modal-body.info-perfil-image .form-group > .form-label:nth-child(1) {
            width: 20%;
            text-align: center;
        }
        .edit_user.dark .container.edit_user_portal {
            background-color: #1c1c1c;
        }
        .edit_user.dark h5.modal-title {
            color: white;
        }
        .edit_user.dark .modal-body.double.edit_user {
            background-color: #1c1c1c;
        }
        .edit_user.dark span.text {
            color: white;
        }
        button.btn.btn-primary {
            background-color: black;
            border-color: white;
        }

        button.btn.btn-secondary {
            background-color: black;
            border-color: #ffffff !important;
            border: 1px solid;
        }
    </style>
